import { render, staticRenderFns } from "./medicine-duplicate.vue?vue&type=template&id=b7c85f92&"
import script from "./medicine-duplicate.vue?vue&type=script&lang=js&"
export * from "./medicine-duplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports